var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddmarks(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffebd4;}.cls-2{fill:#f4971c;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15,
    cy: 15,
    r: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.79,14.89c0-1.53,0-3.07,0-4.61A2.73,2.73,0,0,1,11,7.55a2.56,2.56,0,0,1,.55,0H18.1a2.74,2.74,0,0,1,2.77,2.76V14.7a.55.55,0,0,1-.39.57.51.51,0,0,1-.6-.21.83.83,0,0,1-.1-.38c0-1.48,0-2.95,0-4.42a1.62,1.62,0,0,0-1.22-1.6,1.54,1.54,0,0,0-.48-.06H11.59a1.64,1.64,0,0,0-1.7,1.7q0,4.6,0,9.23a1.64,1.64,0,0,0,1.7,1.7H14a.55.55,0,0,1,.54.4.53.53,0,0,1-.23.6.67.67,0,0,1-.34.09H11.47a2.73,2.73,0,0,1-2.68-2.69c0-1.58,0-3.16,0-4.74Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.23,16.29a3.85,3.85,0,1,1-3.85,3.83A3.84,3.84,0,0,1,19.23,16.29Zm-2.75,3.83a2.75,2.75,0,1,0,2.76-2.74A2.75,2.75,0,0,0,16.48,20.12Z",
    transform: "translate(0 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.83,13.54h2.68a.55.55,0,1,1,0,1.1H12.14a.55.55,0,1,1,0-1.1Z",
    transform: "translate(0 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14,11.89H12.08a.54.54,0,0,1-.54-.49.54.54,0,0,1,.41-.59l.16,0H15.9a.56.56,0,0,1,.54.75.56.56,0,0,1-.55.35Z",
    transform: "translate(0 0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.68,16.83c-.51,0-1,0-1.54,0a.55.55,0,1,1,0-1.09h3.11a.55.55,0,1,1,0,1.09C14.72,16.84,14.2,16.83,13.68,16.83Z",
    transform: "translate(0 0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13,17.93H14A.55.55,0,1,1,14,19H12.11a.56.56,0,0,1-.58-.55.56.56,0,0,1,.59-.55Z",
    transform: "translate(0 0)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.74,
    y: 18.54,
    width: 1.1,
    height: 3.17,
    rx: 0.55
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.74,
    y: 18.54,
    width: 1.1,
    height: 3.17,
    rx: 0.55,
    transform: "translate(-0.84 39.42) rotate(-90)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddmarks);
export default __webpack_public_path__ + "static/media/addmarks.5bc7f85cd214c5b6127f17690aedbcc2.svg";
export { ForwardRef as ReactComponent };